/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasOperation } from '../../openapi/models/OasOperation';

/**
 * A command used to create a new request body (parameter of an operation).
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class NewRequestBodyCommand extends AbstractCommand {
    public _operationPath : NodePath;

    public _created : boolean;

    public constructor(operation? : any) {
        if(((operation != null && operation instanceof <any>OasOperation) || operation === null)) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._created===undefined) this._created = false;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._created===undefined) this._created = false;
            (() => {
                this._operationPath = Library.createNodePath(operation);
            })();
        } else if(operation === undefined) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._created===undefined) this._created = false;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewRequestBodyCommand] Executing.");
        this._created = false;
        let operation : OasOperation = <OasOperation>this._operationPath.resolve(document);
        if(this.isNullOrUndefined(operation)) {
            return;
        }
        if(this.hasRequestBody(operation)) {
            return;
        }
        this.doCreateRequestBody(operation);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewRequestBodyCommand] Reverting.");
        if(!this._created) {
            return;
        }
        let operation : OasOperation = <OasOperation>this._operationPath.resolve(document);
        if(this.isNullOrUndefined(operation)) {
            return;
        }
        this.doRemoveRequestBody(operation);
    }

    /**
     * Returns true if the given operation already has a body parameter.
     * @param {OasOperation} operation
     * @return {boolean}
     */
    abstract hasRequestBody(operation : OasOperation) : boolean;

    /**
     * Creates an empty request body for the given operation.
     * @param {OasOperation} operation
     */
    abstract doCreateRequestBody(operation : OasOperation);

    /**
     * Removes the request body.
     * @param {OasOperation} operation
     */
    abstract doRemoveRequestBody(operation : OasOperation);
}
NewRequestBodyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand";
NewRequestBodyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




